import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";
import { Spinner, SpinnerSize } from "@fluentui/react";
import EV2Experiments from "./Shared/EV2Experiments";
import TopBar from "./Layout/TopBar";
import "./App.css";
import { useFetchExtensionFolders } from "./Hooks/AdoHooks/UseFetchExtensionFolders";
import { styles } from "./Shared/shared.styles";
import { AppProvider } from "./Contexts";
import { ErrorMessageBar } from "./Shared/ErrorMessageBar";
import { useGetFeatureParam } from "./Hooks/UseFeature";
import { AcceptedFeatures } from "./Shared/shared.consts";
import ExtensionDetails from "./Experiment/ExtensionDetails/ExtensionDetails";
import { SessionProvider } from "./Contexts/SessionContext";
import { useCheckRepoAccess } from "./Hooks/AdoHooks/UseCheckRepoAccess";
import ADOAccessErrorMessageBar from "./Shared/ADOAccessErrorMessageBar";

const App: React.FC = () => {
  const [error, setError] = useState<string | null>(null);
  const hideTopBar = useGetFeatureParam(AcceptedFeatures.hideTopBar.key);

  const { hasAccess, loading: loadingAccess } = useCheckRepoAccess();

  const { value: extensions = [], loading } =
    useFetchExtensionFolders(setError);

  if (loading || loadingAccess) {
    return (
      <div className={styles.loadingSpinner}>
        <Spinner label="Loading extensions..." size={SpinnerSize.large} />
      </div>
    );
  }

  return (
    <AppProvider initialExtensions={extensions} extensionError={error}>
      <div className="App" data-testid="app-container">
        {!hideTopBar && <TopBar extensions={extensions} />}
        <ErrorMessageBar />
        {!hasAccess && <ADOAccessErrorMessageBar />}
        <Routes>
          <Route
            path="/extensions/:extensionName/experiment/:experimentName/clone"
            element={<EV2Experiments isClone={true} />}
          />
          <Route
            path="/extensions/:extensionName/experiment/create"
            element={<EV2Experiments isCreate={true} />}
          />
          <Route
            path="/extensions/:extensionName/experiment/:experimentName"
            element={<EV2Experiments />}
          />
          <Route
            path="/extensions/:extensionName"
            element={<EV2Experiments />}
          />
          <Route
            path="/extensions"
            element={<EV2Experiments isRoot={true} />}
          />
          <Route
            path="/extensions/:extensionName/extensionDetails"
            element={
              <SessionProvider>
                <ExtensionDetails />
              </SessionProvider>
            }
          />
          <Route path="/" element={<EV2Experiments isRoot={true} />} />
        </Routes>
      </div>
    </AppProvider>
  );
};

export default App;
